<template>
  <div class="record-container">
    <div class="record-table">
      <div class="title">
        <div class="info"></div>
        <div class="complaint-btn" @click="goForm">继续投诉</div>
      </div>
      <div class="record-header" v-if="pageData && pageData.length > 0">
        <div class="label">申诉单号</div>
        <div class="label">提交时间</div>
        <div class="label">处理进度</div>
        <div class="label">处理说明</div>
      </div>
      <div v-if="pageData && pageData.length > 0">
        <div
          v-for="(item, index) in pageData"
          :key="index"
          class="record-content"
        >
          <div class="item cursor" @click="goDetail(item.id)">
            {{ item.complaintNum }}
          </div>
          <div class="item">{{ item.createTime }}</div>
          <div class="item">{{ getStatus(item.status) }}</div>
          <div class="item hover" :title="item.note">{{ item.note }}</div>
          <div class="popup">{{ item.note }}</div>
        </div>
      </div>
      <div class="not-found" v-if="pageData && pageData.length === 0">
        无投诉记录
      </div>
    </div>
    <HyPagination
      v-if="pageData && pageData.length > 0"
      :config="pageConfig"
      @changeCurrentPage="changeCurrentPage"
    />
  </div>
</template>

<script>
import HyPagination from "../../components/HyPagination";
import { getRecordList } from "../../api/audit";

export default {
  components: {
    HyPagination
  },
  data() {
    return {
      pageConfig: { pageNum: 1, pageTotal: 2 },
      pageData: [],
      isActive: false
    };
  },
  created() {
    getRecordList({
      page: this.pageConfig.pageNum - 1,
      size: 10
    }).then(res => {
      const data = res.data;
      this.pageData = data.content || [];
      this.pageConfig = {
        pageNum: data.pageable.pageNumber,
        pageTotal: data.totalPages
      };
    });
  },
  methods: {
    mouseEnter() {
      this.isActive = true;
    },
    mouseOut() {
      this.isActive = false;
    },
    goForm() {
      this.$router.push({
        name: "form"
      });
    },
    getStatus(status) {
      const desc = {
        1: "未处理",
        2: "处理中",
        3: "已处理",
        4: "无效"
      };
      return desc[status];
    },
    goDetail(id) {
      this.$router.push({
        name: "detail",
        params: {
          id: id
        }
      });
    },
    changeCurrentPage(pageNum) {
      getRecordList({
        page: pageNum - 1,
        size: 10
      }).then(res => {
        const data = res.data;
        this.pageData = data.content;
        this.pageConfig = {
          pageNum: data.pageable.pageNumber,
          pageTotal: data.totalPages
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.record-container {
  min-width: 960px;
  width: 70%;
  border-radius: 10px;
  border: 1px solid rgba(151, 151, 151, 1);
  margin: 0 auto;
  box-sizing: border-box;
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 60vh;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  .info {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(105, 105, 105, 1);
  }
  .complaint-btn {
    width: 131px;
    height: 42px;
    background: rgba(42, 151, 212, 1);
    border-radius: 10px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
.record-header {
  height: 53px;
  background: rgba(242, 242, 242, 1);
  border-radius: 4px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  .label {
    flex: 1;
    text-align: center;
  }
}
.record-content {
  height: 53px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(151, 151, 151, 1);
  position: relative;
  .item {
    flex: 1;
    text-align: center;
  }
  .cursor {
    cursor: pointer;
  }
  .item.cursor:hover {
    color: rgba(42, 151, 212, 1);
  }
  .hover {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      + .popup {
        display: block;
      }
    }
  }
  .popup {
    position: absolute;
    width: 200px;
    padding: 20px;
    right: 0;
    top: -100px;
    word-break: break-all;
    background: #fff;
    border-radius: 20px;
    border: 1px solid #000;
    display: none;
    white-space: pre-line;
    z-index: 111;
  }
}
.not-found {
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #696969;
  padding: 151px 0;
}
</style>
